var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6684 0.382584C12.9276 0.13448 13.2725 -0.00268272 13.6304 3.97663e-05C13.9883 0.00276225 14.3311 0.145157 14.5865 0.397177C14.842 0.649196 14.9901 0.991129 14.9995 1.35082C15.009 1.71052 14.8791 2.05984 14.6372 2.32508L7.29535 11.5565C7.16911 11.6933 7.01674 11.803 6.84735 11.8791C6.67797 11.9553 6.49505 11.9963 6.30954 11.9998C6.12402 12.0032 5.93972 11.969 5.76764 11.8992C5.59557 11.8294 5.43927 11.7255 5.30807 11.5935L0.439241 6.69846C0.303652 6.57144 0.194899 6.41826 0.119471 6.24806C0.0440431 6.07786 0.00348419 5.89413 0.000214773 5.70783C-0.00305464 5.52153 0.0310325 5.33648 0.100442 5.16371C0.169851 4.99094 0.273161 4.834 0.404209 4.70225C0.535257 4.57049 0.691357 4.46663 0.863198 4.39684C1.03504 4.32706 1.2191 4.29279 1.4044 4.29608C1.5897 4.29936 1.77245 4.34014 1.94173 4.41598C2.11102 4.49181 2.26337 4.60115 2.38972 4.73747L6.24283 8.60951L12.6334 0.423284C12.6449 0.409041 12.6572 0.395453 12.6702 0.382584H12.6684Z",
    fill: "#5FCF78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.4f01031739e1dbdda6f7354ca9f17add.svg";
export { ForwardRef as ReactComponent };